import * as React from 'react';

import { CollapsibleSection, RelationSelect, Wrapper } from 'common/components';
import { PlainCheckbox } from 'common/components/Checkbox';
import { RelationOption } from 'common/components/RelationSelect';
import { PK } from 'common/types';
import { useActiveFilter, useContentItems, useUpdateContentItems } from '../hooks';
import { MinimalContent } from '../../../base/api/types';

interface StaticPickerProps {
  pk?: PK;
  divider?: boolean;
  forceOpen?: boolean;
  sectionTitle: string;
  contentList: MinimalContent[];
  collectionItems: PK[];
}

const StaticPicker = ({
  pk,
  divider,
  forceOpen,
  collectionItems,
  contentList,
  sectionTitle,
}: StaticPickerProps) => {
  const contentItems = useContentItems(collectionItems, contentList);

  const { filterEnabled, toggleActiveFilter, activeFilter } = useActiveFilter();
  const options: RelationOption[] = React.useMemo(() => {
    return contentList.filter(activeFilter).map(({ pk, title }) => ({
      label: title,
      value: pk,
    }));
  }, [contentList, activeFilter]);

  const {
    save: updateItems,
    isSuccess: isUpdateSuccess,
    isLoading: isUpdateLoading,
    isError: isUpdateError,
    error: updateError,
  } = useUpdateContentItems(pk);

  const saveStatus = {
    isSuccess: isUpdateSuccess,
    isLoading: isUpdateLoading,
    isError: isUpdateError,
    error: updateError,
  };

  const handleSave = (items: RelationOption[]) => {
    updateItems({ items });
  };

  return (
    <CollapsibleSection
      title={sectionTitle}
      saveStatus={saveStatus}
      disabled={!pk}
      divider={divider}
      shouldOpen={forceOpen}
      hideArrow
    >
      <PlainCheckbox
        name="active_only"
        label="Filter only active items"
        checked={filterEnabled}
        onChange={toggleActiveFilter}
      />
      <Wrapper margin={[1, 0, 1]}>
        <RelationSelect
          onSave={handleSave}
          options={options}
          defaultValues={contentItems}
          isLoading={isUpdateLoading}
        />
      </Wrapper>
    </CollapsibleSection>
  );
};

export default StaticPicker;
